import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";
import "./Hero.css";
import SEO from "../SEO";

export default function Hero() {
  useEffect(() => {
    AOS.init({ once: true, duration: 900, mirror: false });
  }, []);
  const projects = [
    {
      id: 1,
      name: "Clothing E-Commerce Store",
      category: "website",
      icon: "🛍️",
      description: "Modern fashion store with cart & checkout system.",
      image: "/img/Anabiyahscollection.png",
      video: "",
      url: "https://anabiyhscollections.com/",
    },
    {
      id: 2,
      name: "Solar Energy Website",
      category: "website",
      icon: "☀️",
      description: "Lead generation website for solar business.",
      image: "/img/SolidERA-Energy.png",
      video: "",
      url: "http://solidera-energy.com/",
    },
    {
      id: 3,
      name: "Pharmacy Distributor Website",
      category: "website",
      icon: "💊",
      description: "Corporate pharma website with product listing.",
      image: "/img/ags.png",
      video: "",
      url: "https://web.agssukkur.com/",
    },
    {
      id: 4,
      name: "POS System",
      category: "software",
      icon: "🛒",
      description: "Billing + inventory management system.",
      video: "https://www.youtube.com/embed/MWEID7Io39s",
      url: "/Portfolio/EnterpriseERP/index",
    },
    {
      id: 5,
      name: "Advanced POS",
      category: "software",
      icon: "💳",
      description: "Touch POS with advanced controls.",
      video: "https://www.youtube.com/embed/gTiGXKNYYEE",
      url: "/Portfolio/EnterpriseERP/index",
    },
    {
      id: 6,
      name: "ERP System",
      category: "software",
      icon: "📦",
      description: "Complete ERP for business automation.",
      video: "https://www.youtube.com/embed/6unp9xeoQMQ",
      url: "/Portfolio/EnterpriseERP/index",
    },
  ];
  return (
    <>
      <SEO
        title="Custom Software, ERP, POS & Web Development Company in Pakistan | MZR Software"
        description="Looking for the best ERP, POS or inventory software in Pakistan? MZR Software offers affordable, fast and scalable solutions for businesses. Get free consultation today."
        url="https://mzrsoftware.com/"
      />
      <div className="page-shell">
        <header className="site-header sticky-header" data-aos="fade-down">
          <div className="container header-inner">
            <nav className="nav-links">
              <a href="#services">Services</a>
              <a href="#why">Why Us</a>
              <a href="#portfolio">Portfolio</a>
              <a href="#testimonials">Testimonials</a>
            </nav>
            <Link to="/Contact/index" className="btn header-cta">
              Get Quote
            </Link>
          </div>
        </header>

        <main>
          <section className="hero-section" id="home">
            <div className="hero-overlay"></div>
            <div className="hero-decor hero-decor-1" />
            <div className="hero-decor hero-decor-2" />

            <div className="container hero-grid">
              {/* LEFT */}
              <div className="hero-copy" data-aos="fade-right">
                <div className="hero-badges">
                  <span>🔥 100+ Projects</span>
                  <span>⚡ 2–5 Days Delivery</span>
                  <span>💰 Starting from $99</span>
                </div>

                <h1>
                  Custom Software Development, ERP, POS & Web Solutions in
                  Pakistan
                </h1>

                <h2 className="hero-subheading">
                  We design and develop custom software, ERP systems, POS
                  solutions, websites and e-commerce platforms to automate your
                  business and increase growth.
                </h2>

                <p>
                  MZR Software is a leading software house in Pakistan providing
                  ERP systems, POS software, custom applications, web
                  development and e-commerce solutions. We help startups, shops
                  and enterprises automate operations and scale faster with
                  modern, high-performance systems.
                </p>

                <div className="hero-actions">
                  <a
                    href="https://wa.me/923351206586?text=Hi%20I%20need%20ERP%20or%20website%20services"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-primary glow-btn"
                  >
                    🚀 Get Free Consultation on WhatsApp
                  </a>

                  <Link to="/portfolio" className="btn btn-secondary">
                    View Portfolio →
                  </Link>
                </div>

                {/* TRUST */}
                <div className="hero-trust">
                  ✔ Free Consultation • ✔ Fast Delivery • ✔ Affordable Pricing
                </div>
              </div>

              {/* RIGHT */}
              <div className="hero-panel" data-aos="fade-left">
                <div className="hero-card">
                  <div className="panel-icon">📊</div>
                  <h3>ERP Software</h3>
                  <p>Manage inventory, accounts & reports in one system.</p>
                </div>
                <div className="hero-card">
                  <div className="panel-icon">🌐</div>
                  <h3>Website Development</h3>
                  <p>
                    Professional business websites designed for performance, SEO
                    and conversions.
                  </p>
                </div>
                <div className="hero-card">
                  <div className="panel-icon">🛍️</div>
                  <h3>E-Commerce Solutions</h3>
                  <p>
                    Online stores with cart, checkout and payment integration to
                    grow your sales.
                  </p>
                </div>
                <div className="hero-card">
                  <div className="panel-icon">🛒</div>
                  <h3>POS System</h3>
                  <p>Fast billing, sales tracking & inventory control.</p>
                </div>

                <div className="hero-card">
                  <div className="panel-icon">🌐</div>
                  <h3>Business Website</h3>
                  <p>Modern, fast & SEO-optimized websites that convert.</p>
                </div>
              </div>
            </div>
          </section>
          <section className="section services-section" id="services">
            <div className="container">
              <div className="section-head text-center" data-aos="fade-up">
                <p className="eyebrow">Services</p>
                <h2>
                  Custom Software, ERP, POS, Web & E-Commerce Development
                  Services in Pakistan
                </h2>
                <p className="section-copy">
                  We build scalable ERP systems, POS software, business
                  websites, and custom software solutions including inventory
                  management and accounting systems for startups and
                  enterprises.
                </p>
              </div>

              <div className="services-grid">
                <div
                  className="service-card"
                  data-aos="fade-up"
                  data-aos-delay="100"
                >
                  <div className="service-icon">📊</div>
                  <h3>ERP Software</h3>
                  <p>
                    Complete business management system including inventory,
                    accounts, and reporting.
                  </p>
                  <span className="service-cta">Starting from $150</span>
                </div>

                <div
                  className="service-card"
                  data-aos="fade-up"
                  data-aos-delay="150"
                >
                  <div className="service-icon">💳</div>
                  <h3>POS System</h3>
                  <p>
                    Fast billing, stock control, and real-time sales tracking
                    for shops and stores.
                  </p>
                  <span className="service-cta">Delivered in 2–3 days</span>
                </div>
                <div
                  className="service-card"
                  data-aos="fade-up"
                  data-aos-delay="150"
                >
                  <div className="service-icon">🌐</div>
                  <h3>Website Development</h3>
                  <p>
                    Professional business websites designed for performance, SEO
                    and conversions.
                  </p>
                  <span className="service-cta">Delivered in 2–3 days</span>
                </div>

                <div
                  className="service-card"
                  data-aos="fade-up"
                  data-aos-delay="150"
                >
                  <div className="service-icon">🛍️</div>
                  <h3>E-Commerce Solutions</h3>
                  <p>
                    Online stores with cart, checkout and payment integration to
                    grow your sales.
                  </p>
                  <span className="service-cta">Delivered in 2–3 days</span>
                </div>

                <div
                  className="service-card"
                  data-aos="fade-up"
                  data-aos-delay="250"
                >
                  <div className="service-icon">⚙️</div>
                  <h3>Custom Software</h3>
                  <p>
                    Tailored solutions built exactly according to your business
                    workflow and needs.
                  </p>
                  <span className="service-cta">100% Custom Solution</span>
                </div>
                <div
                  className="service-card"
                  data-aos="fade-up"
                  data-aos-delay="400"
                >
                  <div className="service-icon">⚛️</div>
                  <h3>React Web Apps</h3>
                  <p>
                    High-performance React JS applications for modern
                    businesses.
                  </p>
                  <span className="service-cta">Fast & Scalable</span>
                </div>

                <div
                  className="service-card"
                  data-aos="fade-up"
                  data-aos-delay="450"
                >
                  <div className="service-icon">🧾</div>
                  <h3>Accounting Software</h3>
                  <p>
                    Manage accounts, expenses, and financial reports بسهولة.
                  </p>
                  <span className="service-cta">Business Ready</span>
                </div>
                <div
                  className="service-card"
                  data-aos="fade-up"
                  data-aos-delay="300"
                >
                  <div className="service-icon">📱</div>
                  <h3>Mobile Apps</h3>
                  <p>
                    Android & iOS apps for your business with modern UI and
                    smooth performance.
                  </p>
                  <span className="service-cta">Grow your mobile presence</span>
                </div>

                {/* EXTRA (important for grid balance) */}
                <div
                  className="service-card"
                  data-aos="fade-up"
                  data-aos-delay="350"
                >
                  <div className="service-icon">🌐</div>
                  <h3>Business Website</h3>
                  <p>
                    Professional websites for companies, startups, and service
                    businesses.
                  </p>
                  <span className="service-cta">Modern & SEO Friendly</span>
                </div>
              </div>
            </div>
          </section>
          <section className="section services-section">
            <div className="container">
              <h2>Software Development Company in Pakistan</h2>
              <p>
                MZR Software is a full-service software development company in
                Pakistan offering ERP systems, POS software, custom business
                applications, e-commerce websites and modern web development
                services. We help startups, shops and enterprises build scalable
                and efficient digital solutions.
              </p>
            </div>
          </section>
          <section className="section services-section">
            <div className="container">
              <h2>ERP Software & POS System Company in Pakistan</h2>
              <p>
                MZR Software is a trusted ERP software and POS system provider
                in Pakistan. We develop custom business software including
                inventory systems, accounting solutions, and web applications
                tailored to your needs. Our expert team delivers
                high-performance solutions using modern technologies like React
                JS and .NET.
              </p>

              <h3>Custom Software Development Services</h3>
              <p>
                From startups to enterprises, we provide scalable and secure
                custom software solutions including ERP systems, POS software,
                web development, and mobile applications to help your business
                grow faster.
              </p>
            </div>
          </section>
          <section className="section services-section" id="why">
            <div className="container">
              <div className="section-head text-center" data-aos="fade-up">
                <p className="eyebrow">Why Choose Us</p>
                <h2>Why Choose MZR Software for ERP, POS & Web Development?</h2>
                <p className="section-copy">
                  We help businesses grow with reliable, scalable, and
                  budget-friendly software solutions.
                </p>
              </div>

              <div className="why-grid">
                <div
                  className="why-card"
                  data-aos="fade-up"
                  data-aos-delay="100"
                >
                  <div className="why-icon">⚡</div>
                  <h3>Fast Delivery</h3>
                  <p>
                    Get your website or software delivered quickly without
                    compromising quality.
                  </p>
                </div>

                <div
                  className="why-card"
                  data-aos="fade-up"
                  data-aos-delay="150"
                >
                  <div className="why-icon">💰</div>
                  <h3>Affordable Pricing</h3>
                  <p>
                    Budget-friendly solutions designed for startups and small
                    businesses.
                  </p>
                </div>

                <div
                  className="why-card"
                  data-aos="fade-up"
                  data-aos-delay="200"
                >
                  <div className="why-icon">🛠️</div>
                  <h3>Custom Solutions</h3>
                  <p>
                    Every project is tailored to your exact business needs and
                    workflow.
                  </p>
                </div>

                <div
                  className="why-card"
                  data-aos="fade-up"
                  data-aos-delay="250"
                >
                  <div className="why-icon">🕒</div>
                  <h3>24/7 Support</h3>
                  <p>
                    Ongoing support and quick assistance whenever you need help.
                  </p>
                </div>
              </div>
            </div>
          </section>
          <section className="section portfolio-section" id="portfolio">
            <div className="container">
              <div className="section-head" data-aos="fade-up">
                <p className="eyebrow">Portfolio</p>
                <h2>Recent Projects</h2>
              </div>

              <div className="portfolio-grid">
                {projects.map((project) => {
                  const isExternal = project.url.startsWith("http");

                  const Card = (
                    <div className="portfolio-card">
                      <div className="card-image-wrapper">
                        {/* MEDIA */}
                        {project.video ? (
                          <iframe
                            src={project.video}
                            className="project-video"
                            title={project.name}
                          ></iframe>
                        ) : (
                          <img
                            src={project.image}
                            alt={project.name}
                            className="project-image"
                          />
                        )}

                        {/* OVERLAY */}
                        <div className="card-overlay">
                          <span className="project-icon">{project.icon}</span>
                          <span className="visit-icon">View Project</span>
                        </div>
                      </div>

                      <div className="card-content">
                        <h3>{project.name}</h3>
                        <span className="category-badge">
                          {project.category}
                        </span>
                        <p>{project.description}</p>
                        <span className="card-cta">Click to open →</span>
                      </div>
                    </div>
                  );

                  return isExternal ? (
                    <a
                      key={project.id}
                      href={project.url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {Card}
                    </a>
                  ) : (
                    <Link key={project.id} to={project.url}>
                      {Card}
                    </Link>
                  );
                })}
              </div>
            </div>
          </section>
          <section className="section testimonial-section" id="testimonials">
            <div className="container">
              <div className="section-head text-center" data-aos="fade-up">
                <p className="eyebrow">Client Feedback</p>
                <h2>Trusted by Businesses Across Multiple Industries</h2>
                <p className="section-copy">
                  Real results delivered for startups, retailers, and companies
                  worldwide.
                </p>
              </div>

              <div className="testimonial-grid">
                {/* 1 */}
                <div
                  className="testimonial-card"
                  data-aos="fade-up"
                  data-aos-delay="100"
                >
                  <p>
                    “MZR Software delivered our ERP system faster than expected.
                    Everything from inventory to accounts is now fully
                    automated. Highly recommended.”
                  </p>
                  <div className="testimonial-author">
                    <strong>Ali Khan</strong>
                    <span>Operations Head</span>
                  </div>
                </div>

                {/* 2 */}
                <div
                  className="testimonial-card"
                  data-aos="fade-up"
                  data-aos-delay="150"
                >
                  <p>
                    “The POS system completely improved our store workflow. It’s
                    fast, reliable, and very easy for staff to use.”
                  </p>
                  <div className="testimonial-author">
                    <strong>Sarah Malik</strong>
                    <span>Retail Manager</span>
                  </div>
                </div>

                {/* 3 */}
                <div
                  className="testimonial-card"
                  data-aos="fade-up"
                  data-aos-delay="200"
                >
                  <p>
                    “Our website was delivered quickly and looks very
                    professional. We started getting leads within days.”
                  </p>
                  <div className="testimonial-author">
                    <strong>Faizan R.</strong>
                    <span>Founder</span>
                  </div>
                </div>

                {/* 4 */}
                <div
                  className="testimonial-card"
                  data-aos="fade-up"
                  data-aos-delay="250"
                >
                  <p>
                    “Our fashion store website turned out amazing. Clean design,
                    smooth checkout, and mobile-friendly. Really impressed!”
                  </p>
                  <div className="testimonial-author">
                    <strong>Anabiyahs Collections</strong>
                    <span>E-Commerce Store Owner</span>
                  </div>
                </div>

                {/* 5 NEW */}
                <div
                  className="testimonial-card"
                  data-aos="fade-up"
                  data-aos-delay="300"
                >
                  <p>
                    “MZR Software developed our pharmaceutical website with a
                    professional look and smooth performance. It represents our
                    business perfectly.”
                  </p>
                  <div className="testimonial-author">
                    <strong>AGS & Sons</strong>
                    <span>Pharma Distributor</span>
                  </div>
                </div>

                {/* 6 NEW */}
                <div
                  className="testimonial-card"
                  data-aos="fade-up"
                  data-aos-delay="350"
                >
                  <p>
                    “Our solar company website was built exactly how we wanted.
                    Clean UI, fast loading, and great support throughout the
                    project.”
                  </p>
                  <div className="testimonial-author">
                    <strong>Rais Farhan</strong>
                    <span>SolidERA Energy</span>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="section services-section">
            <div className="container">
              <div className="section-head text-center mb-4">
                <p className="eyebrow">FAQs</p>
                <h2>ERP & POS Software Questions Answered</h2>
                <p className="section-copy">
                  Everything you need to know about ERP, POS and business
                  software in Pakistan.
                </p>
              </div>

              <div className="accordion" id="faqAccordion">
                {/* 1 */}
                <div className="accordion-item">
                  <h2 className="accordion-header" id="faq1">
                    <button
                      className="accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse1"
                    >
                      Which is the best ERP software in Pakistan?
                    </button>
                  </h2>
                  <div
                    id="collapse1"
                    className="accordion-collapse collapse show"
                    data-bs-parent="#faqAccordion"
                  >
                    <div className="accordion-body">
                      MZR Software provides one of the best ERP systems in
                      Pakistan with inventory, accounting, reporting and
                      automation features for all types of businesses.
                    </div>
                  </div>
                </div>

                {/* 2 */}
                <div className="accordion-item">
                  <h2 className="accordion-header" id="faq2">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse2"
                    >
                      What is the price of POS system in Pakistan?
                    </button>
                  </h2>
                  <div
                    id="collapse2"
                    className="accordion-collapse collapse"
                    data-bs-parent="#faqAccordion"
                  >
                    <div className="accordion-body">
                      POS system prices vary based on features. MZR Software
                      offers affordable POS solutions with billing, inventory
                      and reporting features for shops and businesses.
                    </div>
                  </div>
                </div>

                {/* 3 */}
                <div className="accordion-item">
                  <h2 className="accordion-header" id="faq3">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse3"
                    >
                      What features should a POS system have?
                    </button>
                  </h2>
                  <div
                    id="collapse3"
                    className="accordion-collapse collapse"
                    data-bs-parent="#faqAccordion"
                  >
                    <div className="accordion-body">
                      A good POS system includes billing, inventory tracking,
                      barcode support, sales reports and user management. Our
                      POS system covers all these features.
                    </div>
                  </div>
                </div>

                {/* 4 */}
                <div className="accordion-item">
                  <h2 className="accordion-header" id="faq4">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse4"
                    >
                      Do you provide custom ERP and software solutions?
                    </button>
                  </h2>
                  <div
                    id="collapse4"
                    className="accordion-collapse collapse"
                    data-bs-parent="#faqAccordion"
                  >
                    <div className="accordion-body">
                      Yes, MZR Software builds fully customized ERP, POS and
                      business software tailored to your workflow and business
                      needs.
                    </div>
                  </div>
                </div>

                {/* 5 */}
                <div className="accordion-item">
                  <h2 className="accordion-header" id="faq5">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse5"
                    >
                      Can I get a demo before purchasing?
                    </button>
                  </h2>
                  <div
                    id="collapse5"
                    className="accordion-collapse collapse"
                    data-bs-parent="#faqAccordion"
                  >
                    <div className="accordion-body">
                      Yes, we provide a free demo of ERP and POS systems so you
                      can test everything before making a decision.
                    </div>
                  </div>
                </div>

                {/* 6 */}
                <div className="accordion-item">
                  <h2 className="accordion-header" id="faq6">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse6"
                    >
                      Which businesses can use ERP and POS software?
                    </button>
                  </h2>
                  <div
                    id="collapse6"
                    className="accordion-collapse collapse"
                    data-bs-parent="#faqAccordion"
                  >
                    <div className="accordion-body">
                      Our solutions are ideal for retail shops, supermarkets,
                      pharmacies, wholesalers and growing businesses in
                      Pakistan.
                    </div>
                  </div>
                </div>
              </div>

              {/* CTA */}
              <div className="text-center mt-4">
                <a
                  href="https://wa.me/923351206586?text=Hi%20I%20need%20ERP%20or%20POS%20demo"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-primary"
                >
                  📲 Get Free Demo on WhatsApp
                </a>
              </div>
            </div>
          </section>
          <section className="section services-section" data-aos="fade-up">
            <div className="container final-cta-card">
              <div>
                <p className="eyebrow">Ready to grow your business?</p>
                <h2>Launch your next software project with MZR Software.</h2>
              </div>
              <Link to="/Contact/index" className="btn btn-primary btn-large">
                Start Your Project Now
              </Link>
            </div>
          </section>
        </main>
      </div>
    </>
  );
}
